import type { EditorCommand } from '@atlaskit/editor-common/types';

import {
	AIDefinitionsActionType,
	type AIDefinitionsAction,
} from '../pm-plugins/ai-definitions/actions';
import { getPluginState } from '../pm-plugins/ai-definitions/plugin-factory';
import { aiDefinitionsPluginKey } from '../pm-plugins/ai-definitions/plugin-key';
import type { AIDefinitionsPluginState } from '../pm-plugins/ai-definitions/types';
import type { EditorViewRef } from '../types';

export type EditorCommandUpdateState = (
	state: Partial<
		Pick<AIDefinitionsPluginState, 'enabled' | 'autoHighlightEnabled' | 'enablementSource'>
	>,
) => EditorCommand;

export function updateState({
	editorViewRef,
}: {
	editorViewRef: EditorViewRef;
}): EditorCommandUpdateState {
	return (state) =>
		({ tr }) => {
			if (!editorViewRef.current) {
				return null;
			}
			const pluginState = getPluginState(editorViewRef.current.state);

			const keys = ['enabled', 'autoHighlightEnabled', 'enablementSource'] as const;
			const stateUnchanged = keys.every((key) => {
				return state[key] === undefined || state[key] === pluginState[key];
			});
			if (stateUnchanged) {
				return null;
			}

			const action: AIDefinitionsAction = {
				type: AIDefinitionsActionType.UPDATE_STATE,
				...state,
			};
			return tr.setMeta(aiDefinitionsPluginKey, action);
		};
}
